import { useTileDataContext } from '~/contexts/TileDataContext';
import abbreviateNumber from '~/utilities/abbreviateNumber';

export default function TrimMileage() {
  const {
    tileData: { trim, mileage = 0 }
  } = useTileDataContext();

  return (
    <div
      className="flex gap-4 items-center t-body-s text-blue-6"
      data-qa="trim-mileage"
    >
      <p className="truncate">{trim}</p>
      <span className="shrink-0">•</span>
      <span className="shrink-0">{abbreviateNumber(mileage)} miles</span>
    </div>
  );
}
